<template>
  <div class="uploadIms">
    <el-upload class="upload-demo" accept=".jpg,.png,.jpeg" action="https://jsonplaceholder.typicode.com/posts/"
      :http-request="uploadSectionFile" :before-upload="beforeAvatarUpload" :show-file-list="false">
      <el-button size="small" icon="el-icon-plus" @click="upBtn" type="primary">上传图片</el-button>
    </el-upload>
    <div v-show="imageList.length > 0">
      <el-scrollbar :class="{ 'active': isActive }" ref="srollBarUpload">
        <ul class="ulUpload" ref="ulUpload">
          <li v-for="(item, index) in imageList" :key="index">
            <img :src="item" alt />
            <div class="operation">
              <div class="operation_up">
                <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
                  :http-request="uploadSectionFile" :before-upload="beforeAvatarUpload" :show-file-list="false">
                  <div class="clickBtn" @click="up(index)">向上添加</div>
                </el-upload>
              </div>
              <div class="operation_down">
                <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
                  :http-request="uploadSectionFile" :before-upload="beforeAvatarUpload" :show-file-list="false">
                  <div class="clickBtn" @click="down(index)">向下添加</div>
                </el-upload>
              </div>
              <div class="operation_replace">
                <el-upload class="upload-demo" action="https://jsonplaceholder.typicode.com/posts/"
                  :http-request="uploadSectionFile" :before-upload="beforeAvatarUpload" :show-file-list="false">
                  <div class="clickBtn" @click="replace(index)">替换</div>
                </el-upload>
              </div>
              <div class="operation_delete">
                <div class="clickBtn" @click="del(index)">删除</div>
              </div>
            </div>
          </li>
        </ul>
      </el-scrollbar>
    </div>
  </div>
</template>

<script>
import bus from "../../../components/commonComponents/bus";
import globalUtil from "../../../utils/globalUtil";

export default {
  props: {
    imgList: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    imgList: {
      handler: function (old, news) {
      },
      deep: true
    }
  },
  data() {
    return {
      imageList: this.imgList,
      isActive: false, // 滚动条三元表达
      index: null, // 点击的下标
      isState: null // 点击按钮的类型
    };
  },
  methods: {
    // 自定义上传
    uploadSectionFile(file) {
      let self = this;
      globalUtil.verifyImgWidthAndHeight(file.file, (cfile) => {
        let formData = new FormData();
        let fileName = cfile.name;
        let suffix = fileName.substring(fileName.lastIndexOf(".") + 1);
        formData.append("suffix", suffix);
        formData.append("file", cfile);
        self.uploadFiles(formData, fileName);
      },
        (width) => {
          if (width < 750) {
            this.$message.error("图片宽度要在750px以上");
            return true;
          }
        },
        (height) => {
          if (height > 3000) {
            this.$message.error("图片高度要在3000px以下");
            return true;
          }
        }
      )
    },
    //  企业简介上传文件
    uploadFiles(file, fileName) {
      this.$axios.post(this.$url.uploadFile, file).then(res => {
        if (res.code === 0) {
          // 向上上传
          if (this.isState === "up") {
            if (this.index === 0 || this.index == null) {
              this.imageList.push(res.data);
            } else {
              this.imageList.splice(this.index, 0, res.data);
            }
          }
          // 向下上传
          if (this.isState === "down") {
            this.imageList.splice(this.index + 1, 0, res.data);
          }
          // 替换
          if (this.isState === "replace") {
            this.imageList[this.index] = res.data;
          }
          this.$forceUpdate();
          bus.$emit("imgList", this.imageList);
          this.$nextTick(() => {
            if (this.$refs.ulUpload.offsetHeight > 600) {
              this.isActive = true;
            }
          });
        }
      });
    },
    // 上传前
    beforeAvatarUpload(file) {
      let fileType = ["image/jpeg", "image/png", "image/jpeg"];
      const isJPG = fileType.indexOf(file.type) > -1;

      if (!isJPG) {
        this.$message.error("上传图片只能是JPG/PNG/JPEG格式!");
        return false
      }
      if (file.size > 10 * 1024 * 1024) {
        this.$message.error("上传图片大小不能超过 10MB!");
        return false;
      }
      if (this.imageList.length >= 50) {
        this.$message.error("上传数量不能超过50张");
        return false
      }
      return true;
    },
    // 上传图片
    upBtn() {
      this.index = null;
      this.isState = "up";
    },
    // 向上添加
    up(idx) {
      this.index = idx;
      this.isState = "up";
    },
    // 向下添加
    down(idx) {
      this.index = idx;
      this.isState = "down";
    },
    // 替换
    replace(idx) {
      this.index = idx;
      this.isState = "replace";
    },
    // 删除
    del(idx) {
      this.imageList.splice(idx, 1);
    }
  }
};
</script>


<style lang="less" scoped>
.ulUpload {
  width: 375px;
  display: block;
}

li {
  position: relative;
}

.operation {
  position: absolute;
  top: -20px;
  left: 10px;
  display: flex;
}

.clickBtn {
  padding: 6px 7px;
  background: rgba(0, 0, 0, 1);
  opacity: 0.5;
  border-radius: 3px;
  color: #ffffff;
  cursor: pointer;
}

.operation_down {
  margin: 0 10px;
}

.operation_delete {
  margin-top: 26px;
  margin-left: 10px;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden;
}

.upload-demo {
  margin-top: 25px;
  margin-bottom: 23px;
}

.active {
  height: 600px;
}
</style>
